import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'Components/Button';
import ControllerSelect from 'Components/ControllerSelect';
import Label from 'Components/Label';
import ProgressBar from 'Components/ProgressBar';
import Records from 'Components/Records';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import ConversacionesService from 'Services/Http/Conversaciones.service';
import { TipoPersonaSchema } from 'Services/yup/form';

const ListarPreguntasComponente = () => {
  const navigate = useNavigate();
  const [otps, setOtps] = useState([]);
  const [loader, setLoader] = useState(false);
  const [options, setOptions] = useState([]);
  const [tiposPersonaSeleccionado, setTiposPersonaSeleccionado] = useState('');

  const {
    control,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      tipoPersona: ''
    },
    resolver: yupResolver(TipoPersonaSchema)
  });

  const valueSelect = watch('tipoPersona');
  useEffect(() => {
    if (valueSelect !== '') {
      setTiposPersonaSeleccionado(valueSelect);
    }
  }, [valueSelect]);

  useEffect(() => {
    if (tiposPersonaSeleccionado !== '') {
      getPreguntas();
    }
  }, [tiposPersonaSeleccionado]);

  useEffect(() => {
    getTiposPersona();
  }, []);

  const getTiposPersona = async () => {
    setLoader(true);
    try {
      const response = await ConversacionesService.getTiposPersona();
      const options = Object.keys(response.data).map((key) => {
        return {
          value: key,
          label: response.data[key]
        };
      });
      setOptions(options);
      setLoader(false);
    } catch (e) {
      setLoader(false);
    }
  };

  const getPreguntas = async () => {
    setLoader(true);
    try {
      const response = await ConversacionesService.getPreguntas(tiposPersonaSeleccionado);
      createRows(response.data);
      setLoader(false);
    } catch (e) {
      setLoader(false);
    }
  };

  const deletePregunta = async (id) => {
    setLoader(true);
    try {
      await ConversacionesService.deletePregunta(id);
      getPreguntas();
      setLoader(false);
    } catch (e) {
      setLoader(false);
    }
  };

  const changeOrder = async (id, order) => {
    setLoader(true);
    try {
      await ConversacionesService.changeOrder(id, order);
      getPreguntas();
      setLoader(false);
    } catch (e) {
      setLoader(false);
    }
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'otps-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300">
        <td className="px-6 py-4">{index + 1}</td>
        <td className="px-6 py-4">{item.pregunta}</td>
        <td className="flex px-6 py-4 items-center gap-3">
          <div className="flex flex-col items-center gap-1 cursor-pointer">
            <FontAwesomeIcon
              icon={['fa', 'circle-up']}
              size={'xl'}
              className="text-blue-500 hover:text-blue-700 transition duration-300"
              onClick={() => changeOrder(item.idConversacionPregunta, 'up')}
            />
          </div>
          <div className="text-lg font-bold">{item.orden}</div>
          <div className="flex flex-col items-center gap-1 cursor-pointer">
            <FontAwesomeIcon
              icon={['fa', 'circle-down']}
              size={'xl'}
              className="text-blue-500 hover:text-blue-700 transition duration-300"
              onClick={() => changeOrder(item.idConversacionPregunta, 'down')}
            />
          </div>
        </td>
        <td className="px-6 py-4">
          <Button
            iconprefix={['fa', 'trash']}
            onClick={() => deletePregunta(item.idConversacionPregunta)}
          />
        </td>
      </tr>
    ));
    setOtps(data);
  };

  const goTo = (url) => {
    navigate(url);
  };

  return (
    <>
      <Label text={'Lista de preguntas a enviar'} />
      <div className="flex justify-between my-5">
        <div className="flex">
          <Button iconprefix={['fa', 'rotate']} />
        </div>
        <div className="flex">
          <Button
            label={'Agregar pregunta'}
            color={'primary'}
            onClick={() => goTo('/main/admin/whatsapp/preguntas/crear')}
          />
        </div>
      </div>
      <div className="flex justify-between my-5">
        Para usar el nombre de la persona solicitante en la pregunta, se debe usar el siguiente
        formato: {'{{mutuatario}}'}
      </div>
      <div className="flex flex-col my-5 justify-stretch">
        <ControllerSelect
          data={options}
          control={control}
          name="tipoPersona"
          error={errors?.tipoPersona}
          label="Seleccionar un tipo de persona"
          key="tipoPersona"
        />
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Pregunta
              </th>
              <th scope="col" className="px-6 py-3">
                orden
              </th>
              <th scope="col" className="px-6 py-3"></th>
            </tr>
          </thead>
          <Records items={otps} cols={4} />
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};
export default ListarPreguntasComponente;
